import axios from 'axios';

export const getDropdownRoles = async () => {
    return await axios.get(`${window._HOST}admin/roles/dropdown`, {withCredentials: true});
}
